var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPeopleIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 16 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8.06 12.373c-.65 0-1.17.043-1.61.108-1.83.268-3.37 2.131-3.37 4.042a.83.83 0 1 1-1.66 0c0-2.153 1.35-4.267 3.29-5.216A5.81 5.81 0 0 1 8.06.752a5.81 5.81 0 0 1 5.81 5.81c0 1.96-.97 3.693-2.45 4.745 1.93.949 3.28 3.063 3.28 5.216a.83.83 0 1 1-1.66 0c0-1.911-1.53-3.774-3.36-4.042-.45-.065-.97-.108-1.62-.108Zm0-1.661a4.151 4.151 0 0 1-4.15-4.15 4.151 4.151 0 0 1 8.3 0c0 2.292-1.86 4.15-4.15 4.15Z",
  fill: "currentColor"
})));
export { SvgPeopleIcon as ReactComponent };
export default __webpack_public_path__ + "images/people-icon.svg";